import {
  Account,
  ListAccountRequest,
  ReadAccountRequest,
  AccountServiceClient,
  ListAccountAuditRequest,
  ListGlBankRequest,
  ReadDefaultGlBankRequest,
  ListBankAccountRequest,
  DeleteAccountRequest,
} from '../proto/bankpb/account_grpc_web_pb';

import { auth } from '../lib/auth/Auth';
import authSvc from './AuthService';
import { Pagination } from '../proto/utilspb/pagination_pb';

const service = new AccountServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

const userId = authSvc.getCurrentUser()?.UserId;
const getAcctRequest = (param) => {
  const req = new Account();
  req.setBankId(param.bankId);
  req.setCorrespondent(param.correspondent);
  req.setMasterAccountNo(param.masterAccountNo);
  req.setAccountNo(param.accountNo);
  req.setBankOwnerName(param.bankOwnerName);
  req.setAchRoutingNo(param.achRoutingNo);
  req.setWireRoutingNo(param.wire ?  param.wireRoutingNo : '');
  req.setBankAccountNo(param.bankAccountNo);
  req.setBankAccountType(param.bankAccountType);
  req.setApprovedMethod(param.approvedMethod);
  req.setPlaidAccessToken(param.plaidAccessToken);
  req.setStatus(param.status);
  req.setBankName(param.bankName);
  req.setBankAddressId(param.bankAddressId);
  req.setBankIdentifierCode(param.bankIdentifierCode);
  req.setGlAccountId(param.glAccountId);
  req.setNickName(param.nickName);
  req.setAch(param.ach);
  req.setWire(param.wire);
  req.setCheck(param.check);
  return req;
};

export async function createAccount(param) {
  return new Promise((resolve, reject) => {
    service.createAccount(getAcctRequest(param), {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateAccount(param) {
  return new Promise((resolve, reject) => {
    service.updateAccount(getAcctRequest(param), {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listAccount(param, paging) {
  return new Promise((resolve, reject) => {
    const req = new ListAccountRequest();

    if (paging) {
      let pg = new Pagination();
      pg.setPageNo(paging.pageNo);
      pg.setPageSize(paging.rowsPerPage);
      pg.setSortName(paging.sortName);
      pg.setSortDirection(paging.sortDirection);
      pg.setFilterNamesList(paging.filterNames);
      pg.setFilterValuesList(paging.filterValues);
      req.setPagination(pg);
    }

    req.setCorrespondent(param.correspondent);
    req.setMasterAccountNo(param.masterAccountNo);
    req.setAccountNo(param.accountNo);
    req.setBankName(param.bankName);
    req.setBankOwnerName(param.bankOwnerName);
    req.setAchRoutingNo(param.achRoutingNo);
    req.setBankAccountNo(param.bankAccountNo);
    req.setNickName(param.nickName);
    req.setStatus(param.status);
    req.setUsrId(userId);

    service.listAccount(req, {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listGlBank() {
  return new Promise((resolve, reject) => {
    const req = new ListGlBankRequest();

    service.listGlBank(req, {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readDefaultGlBank() {
  return new Promise((resolve, reject) => {
    const req = new ReadDefaultGlBankRequest();

    service.readDefaultGlBank(req, {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function readAccount(param) {
  return new Promise((resolve, reject) => {
    const req = new ReadAccountRequest();
    req.setBankId(param);

    service.readAccount(req, {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listAccountAudit(id) {
  return new Promise((resolve, reject) => {
    const req = new ListAccountAuditRequest();
    req.setBankId(id);

    service.listAccountAudit(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export const listBankAccount = async (props) => {
  return new Promise((resolve, reject) => {
    const req = new ListBankAccountRequest();
    req.setUserId(props);
    service.listBankAccount(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
};

export async function deleteAccount(id) {
  return new Promise((resolve, reject) => {
    let req = new DeleteAccountRequest();
    req.setBankId(id);
    service.deleteAccount(req, {}, (error, response) => {
      if (error) {
        // notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}
